import resourceService from './resource_service';

const modelName = 'permission';

const attributes = {
  model: '',
  action: '',
};

const relationships = {
  group: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
